import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=525c82ef&scoped=true"
import script from "./MyCenter.vue?vue&type=script&lang=js"
export * from "./MyCenter.vue?vue&type=script&lang=js"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=525c82ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c82ef",
  null
  
)

export default component.exports